//export const API_LINK = 'https://stg-relaxwell.talkk.tech/api/';
export const API_LINK = 'https://relaxwell.talkk.tech/api/';
//export const API_LINK = 'http://localhost:5000/';
// export const API_LINK = 'http://13.200.12.122/';